<div class="modal-header">
    Notifica
    <div class="card-tools">
        <button type="button" class="btn btn-tool" (click)="close('');" >
            <i class="fas fa-times"></i>
        </button>
    </div>
</div>
<div class="modal-body">
    <!-- Seleziona del modello-->
    <ng-container *ngIf="step==0">
        <ng-container *ngIf="loading">
            <div class="m-5 text-center text-secondary">
                <i class="icon fas fa-info-circle mr-2"></i><i>Caricamento del modello in corso ...</i>                
            </div>
        </ng-container>
        <ng-container *ngIf="!loading">
            <div *ngIf="!notifications || notifications.length==0">
                <div class="m-5 text-center">
                    <i class="fas fa-exclamation-circle mr-2"></i>Nessun modello di notifica è presente per questo elemento.
                </div>
            </div>
            <div class="" *ngIf="id_notification==0">
                <div class="row" *ngIf="notifications && notifications.length>0">                    
                    <div class="col-lg-9">
                        <ng-container *ngFor="let n of notifications">
                            <button class="btn btn-outline-primary btn-block" (click)="selectedNotify=n; getNotification()">{{n.name}}</button>
                        </ng-container>
                    </div>
                    <div class="col-lg-3 border-left text-xs d-none d-lg-block">
                        <i class="fa fa-info-circle fa-3x text-gray mb-2"></i><br>
                        Scegli il modello di notifica da utilizzare
                    </div>
                </div>
            </div>
        </ng-container>
    </ng-container >
    <!-- Compilazione modello -->
    <ng-container *ngIf="step==1">
            <div class="row" *ngIf="notifications && notifications.length>0">
                <div class="col-lg-2 border-right">
                    <div class="d-none d-lg-block text-primary"><label>Canali di comunicazione</label></div>
                    <ul class="nav nav-pills flex-column">
                        <ng-container *ngFor="let g of gateway_notifications;let i=index">
                            <li>
                                <a class="nav-link border d-flex align-items-center justify-content-between" [class.active]="tab==i" (click)="tab=i">                                
                                    <span *ngIf="g.gateway=='email'"><i class="far fa-envelope mr-2"></i>Email</span>
                                    <span *ngIf="g.gateway=='sms'"><i class="fas fa-sms mr-2"></i>SMS</span>
                                    <span *ngIf="g.gateway=='whatsapp'"><i class="fab fa-whatsapp mr-2"></i>WhatsApp</span>
                                    <span *ngIf="g.gateway=='app'"><i class="far fa-bell mr-2"></i>Push notification (App)</span>
                                    <input type="checkbox" [(ngModel)]="g.enable">
                                </a>
                            </li>
                        </ng-container>
                    </ul>
                </div>
                <div class="col-lg-10">            
                    <div class="tab-content" id="myTab2Content">
                        <ng-container *ngFor="let g of gateway_notifications;let i=index">
                            <div class="tab-pane fade" [class.active]="tab==i" [class.show]="tab==i">
                                <app-gateway [gateway]="g" [contacts]="contacts" [record]="record" [multipleContact]="multipleContact"></app-gateway>
                            </div>
                        </ng-container>
                    </div>
                 </div>
                 <div class="col-12">
                    <button *ngIf="step==1 && !multipleContact" (click)="close('success');" class="btn btn-outline-success float-right ml-1"><i class="far fa-paper-plane mr-2"></i>Invia</button>
                    <button *ngIf="step==1 && multipleContact" (click)="step=2" class="btn btn-outline-primary float-right ml-1">Invia a...<i class="fa fa-chevron-right ml-2"></i></button>
                    <button class="btn btn-outline-secondary float-right ml-1" (click)="close('');">Annulla</button>
                 </div>
            </div>        
    </ng-container>


    <!-- Elenco utenti-->
     <ng-container *ngIf="step==2">
        <div class="row">
            <div class="col-12">
                <h5>La notifica verrà inviata a ...</h5>
                <table class="table table-sm table-striped">
                    <thead>
                        <th>Anagrafica</th>
                        <th>Utente collegato</th>
                    </thead>
                    <tbody>
                        <tr *ngFor="let a of addresses">
                            <td>{{a.name}}</td>
                            <td>{{a.username}}</td>
                        </tr>
                    </tbody>
                </table>
                <div class="">
                    <button class="btn btn-outline-secondary mr-1" (click)="step=1"><i class="fa fa-chevron-left mr-2"></i>Indietro</button>
                    <button  (click)="close('success');" class="btn btn-outline-success float-right ml-1"><i class="far fa-paper-plane mr-2"></i>Invia</button>
                    <button class="btn btn-outline-secondary float-right ml-1" (click)="close('');">Annulla</button>                    
                </div>
            </div>
        </div>
     </ng-container>